import { connect } from 'react-redux';
import TinyTRRules from '../views/tiny/TinyTRRules';

function mapStateToProps(state, ownProps) {
  return {};
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const TinyTRRulesContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyTRRules);

export default TinyTRRulesContainer;
